import React from "react";

const Description= ({bar_color, description_top_lg, description_top_xs, description_bot_lg, description_bot_xs, description_top_color, description_bot_color}) => {
    return(
        <div className={`w-full h-[133px] overflow-hidden relative flex flex-col`}>
            <hr className={`border-[1px] border-[${bar_color}]`}/>
            <div className="mt-4 ">
                <span style={{color: `${description_top_color}`}} className={`text-[18px] lg:text-[20px] lg:block hidden`}>
                    {description_top_lg}
                </span>
                <span style={{color: `${description_top_color}`}} className={`text-[18px] lg:text-[20px] lg:hidden block`}>
                    {description_top_xs}
                </span>
            </div>
            <div className="mt-4">
                <span style={{color: `${description_bot_color}`}} className={`text-[12px] lg:text-[14px] lg:block hidden`}>
                    {description_bot_lg}
                </span>
                <span style={{color: `${description_bot_color}`}} className={`text-[12px] lg:text-[14px] lg:hidden block`}>
                    {description_bot_xs}
                </span>
            </div>

        </div>
    );
};

export default Description;